import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=572cbbe8&scoped=true&"
import script from "./Panels.vue?vue&type=script&lang=js&"
export * from "./Panels.vue?vue&type=script&lang=js&"
import style0 from "./Panels.vue?vue&type=style&index=0&id=572cbbe8&prod&lang=scss&scoped=true&"
import style1 from "./Panels.vue?vue&type=style&index=1&id=572cbbe8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572cbbe8",
  null
  
)

export default component.exports